// extracted by mini-css-extract-plugin
module.exports = {"ProseMirror":"SampleQuestionsAction_ProseMirror__1ntrS","icon":"SampleQuestionsAction_icon__KB4Df","icon_disabled":"SampleQuestionsAction_icon_disabled__1mosP"};